module.exports = __webpack_public_path__ + "img/magento-support-security_small.c0b9ca5b.webp";